import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUser, setReturnURL} from '../../../utils/commonfunction';
import { ROLE } from "../../../utils/Constants";

const CenterPrivateRoute = ({ component: Component }) => {
    const userData = getUser(ROLE.CENTER)
    return (
        <>
            {(function(){
                if(Object.keys(userData).length && userData.token && userData.role == ROLE.CENTER){
                    return <Component/>
                }else{
                    setReturnURL(ROLE.CENTER);
                    return <Navigate to="/center/login" />;
                }
            })()}
        </>
    )
}

export default CenterPrivateRoute;
